const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/store/nativeAppAuth.ts';
import Imm from 'immutable';
import { IActionHandlersMap, makeReducer, ReducerState } from '@cistec/common_web/defs/actionTypes';
import { appAuthTimeDiffError } from 'App/utils/generalUtils';
import { decCounter, incCounter } from '@cistec/common_web/utils/reducerUtils';
import {
    ACTION_TYPE_NATIVE_PATAPP_AUTHORIZE_FAILURE,
    ACTION_TYPE_NATIVE_PATAPP_AUTHORIZE_PENDING,
    ACTION_TYPE_NATIVE_PATAPP_AUTHORIZE_REFRESH_SUCCESS,
    ACTION_TYPE_NATIVE_PATAPP_AUTHORIZE_RESET_STATE,
    ACTION_TYPE_NATIVE_PATAPP_AUTHORIZE_SES_ERROR,
    ACTION_TYPE_NATIVE_PATAPP_AUTHORIZE_SUCCESS,
    ACTION_TYPE_NATIVE_PATAPP_AUTHORIZE_SUCCESS_FROM_KEYSTORE,
} from 'App/actions/patAppNative';
import { PatAppStoreState } from './setup/rootReducer';

/* PREVIOUSLY NATIVEAPPAUTH */

const initialState = Imm.fromJS({
    loading: 0,
    token: '',
    error: '',
});

const authorizeSuccess = (state: ReducerState, action: any) => {
    state = state.set('error', '');
    if (action.payload) {
        if (!appAuthTimeDiffError(action.payload.accessTokenExpirationDate)) {
            state = state.setIn(['token'], Imm.fromJS(action.payload));
        }
    }
    return state;
};
const handlers: IActionHandlersMap = {
    [ACTION_TYPE_NATIVE_PATAPP_AUTHORIZE_PENDING]: (state: ReducerState, _action: any) => {
        state = state.set('error', '');
        return incCounter(state, ['loading']);
    },
    [ACTION_TYPE_NATIVE_PATAPP_AUTHORIZE_SUCCESS]: (state: ReducerState, action: any) => {
        state = state.set('error', '');
        if (action.payload) {
            state = state.setIn(['token'], Imm.fromJS(action.payload));
        }
        return decCounter(state, ['loading']);
    },
    [ACTION_TYPE_NATIVE_PATAPP_AUTHORIZE_REFRESH_SUCCESS]: authorizeSuccess,
    [ACTION_TYPE_NATIVE_PATAPP_AUTHORIZE_SUCCESS_FROM_KEYSTORE]: authorizeSuccess,
    [ACTION_TYPE_NATIVE_PATAPP_AUTHORIZE_FAILURE]: (state: ReducerState, action: any) => {
        if (action.payload) {
            state = state.setIn(['error'], JSON.stringify(action.payload));
        }
        return decCounter(state, ['loading']);
    },
    [ACTION_TYPE_NATIVE_PATAPP_AUTHORIZE_SES_ERROR]: (state: ReducerState, action: any) => {
        if (action.payload) {
            state = state.setIn(['error'], JSON.stringify(action.payload));
        }
        return state;
    },

    [ACTION_TYPE_NATIVE_PATAPP_AUTHORIZE_RESET_STATE]: (_state: any, _action: any) => {
        return initialState;
    },
};

export const nativeAppAuthReducer = makeReducer(handlers, initialState);

export const appAuthIsLoading = (state: PatAppStoreState): string => state.nativeAppAuth.get('loading');

export const nativeAccessToken = (state: PatAppStoreState): string =>
    state.nativeAppAuth.getIn(['token', 'accessToken']);
